import * as React from 'react';
import MenuItem from '@material-ui/core/MenuItem';

import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { CurrencyFormat } from 'components/CurrencyFormat';
import { IPaymentModel } from 'interfaces/IPaymentModel';
import { IInstallment, IProductConfig } from 'interfaces/IProductData';
import { paymentService } from 'services/PaymentService';
import FieldSelect from 'components/Field/Select';
import { parameterService } from 'services/ParameterService';
import { enParameters } from 'enums/enParameters';
import Grid from '@material-ui/core/Grid/Grid';
import { cartService } from 'services/CartService';
import Translate from 'components/Translate';

interface IState extends IStateBase {
  model: IPaymentModel;
  feeInstallment: number;
  installments: IInstallment[];
  selected?: IInstallment;
  selectedInstallment?: number;
  config: IProductConfig;
  changeInstallment: boolean;
}

export default class Installments extends BaseComponent<IState, { index: number }> {

  constructor(props: any) {
    super(props);

    this.state = {
      model: null,
      feeInstallment: 0,
      installments: null,
      selected: null,
      selectedInstallment: null,
      config: null,
      changeInstallment: false
    };
  }

  componentDidMount() {

    const feeObservable = cartService.getCart().map(c => c.feeInstallment).distinctUntilChanged();

    this.observeState({ feeInstallment: null }, feeObservable);

    paymentService.getPaymentInstallments(this.props.index)
      .map(payment => payment.installments)
      .distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b))
      .bindComponent(this)
      .subscribe(installments => this.setState({ installments }));

    parameterService.get(enParameters.p)
      .take(1)
      .filter(p => !!p)
      .subscribe(p => {
        this.setState({ selectedInstallment: Number(p) || 12 });
      });

    cartService.getCart()
      .take(1)
      .filter(cart => !!cart.installmentSelected)
      .bindComponent(this)
      .subscribe(cart => {
        this.setState({ selectedInstallment: cart.installmentSelected });
      });

    paymentService.getPayment(this.props.index)
      .filter(model => !!model)
      .filter(model => model.installments.length > 1)
      .combineLatest(parameterService.get(enParameters.pr))
      .map(([currentModel, pr]) => {
        const model: IPaymentModel = JSON.parse(JSON.stringify(currentModel));

        if (!pr) {
          model.installments = model.installments.reverse();
        }

        return model;
      })
      .combineLatest(parameterService.get(enParameters.pf))
      .bindComponent(this)
      .debounceTime(50)
      .subscribe(([currentModel, pf]) => {
        const model: IPaymentModel = JSON.parse(JSON.stringify(currentModel));

        const maxInstallments = [...model.installments].sort((a, b) => a.value > b.value ? 1 : -1)[0].installment;

        model.numberInstallments = this.state.selectedInstallment || model.numberInstallments || maxInstallments;

        if (model.numberInstallments > maxInstallments) {
          model.numberInstallments = maxInstallments;
        }

        this.setModel(model);

        let selected = model.installments.find(i => i.installment == model.numberInstallments) || null;

        if (selected && selected.installment > maxInstallments) {
          model.numberInstallments = maxInstallments;
          selected = null;
        }

        if (pf == '1' && !this.state.selectedInstallment && model.installments.length > 1) {
          model.numberInstallments = 0;
          this.enableChangeInstallment();
        }

        selected = model.installments.find(i => i.installment == model.numberInstallments) || null;

        this.setState({
          installments: model.installments,
          selected
        });

        if (selected) {
          paymentService.setPaymentData(
            this.props.index,
            { numberInstallments: selected.installment }
          );
        }
      });
  }

  handleChange = (installment: any) => {

    if (installment === 0) {
      return;
    }

    const selected = this.state.installments.find(i => i.installment == installment) || null;

    this.setState({
      selectedInstallment: installment,
      selected
    });

    setTimeout(() => {
      paymentService.setPaymentData(
        this.props.index,
        { numberInstallments: selected.installment }
      );
    }, 0);

  }

  enableChangeInstallment = () => {
    this.setState({
      changeInstallment: true
    });
  }

  render() {

    const { installments, changeInstallment, model, feeInstallment } = this.state;
    const { index } = this.props;

    let { selected } = this.state;

    if (!installments || installments.length === 1 || selected === undefined || !model) {
      return null;
    }

    selected = selected || { installment: 0, value: 0 };

    return (
      <Grid item xs={12}>
        <div className='chk-installments-wrapper'>
          <label className='chk-input-group'>
            <div>
              {!changeInstallment
                ? <div className='chk-installments__value'>
                  {selected.installment}x
                  <span>
                    <CurrencyFormat value={selected.value} />
                    {feeInstallment === 0 ? <span className='chk-no-fee'><Translate term='SEM JUROS' /></span> : ''}

                  </span>
                  {model.numberInstallments
                    ?
                    <a
                      id={`chk-edit-installments-button-${index}`}
                      className='theme-label'
                      onClick={this.enableChangeInstallment}
                    >
                      Editar Parcelas
                    </a>
                    :
                    <a
                      id={`chk-select-installments-button${index}`}
                      className='theme-label'
                      onClick={this.enableChangeInstallment}
                    >
                      Selecione uma Parcela
                    </a>
                  }
                </div>
                : <Grid item xs={7}>
                  <div className='chk-installments-select zlabel'>
                    <FieldSelect
                      id='installments'
                      className='chk-installments__installmentFieldSelect'
                      value={selected.installment}
                      validation='installments'
                      onChange={this.handleChange}
                      label='Parcelas'
                      InputLabelProps={{
                        className: 'theme-label'
                      }}
                      InputProps={{
                        id: 'installment-combobox'
                      }}
                    >
                      {selected.installment === 0 && <MenuItem value={0}>Selecione uma parcela</MenuItem>}
                      {installments.map((i, key) =>
                        <MenuItem key={key} value={i.installment} id={`installment-${i.installment}-combobox`}>
                          {i.installment}x&nbsp;de&nbsp;
                          <CurrencyFormat value={i.value} />&nbsp;
                          {(i.installment > 1 && feeInstallment > 0) ? '*' : ''}
                          {feeInstallment === 0 ? 'sem juros' : ''}
                        </MenuItem>
                      )}
                    </FieldSelect>
                  </div>
                </Grid>
              }
            </div>
          </label>
        </div>
      </Grid>
    );
  }
}